import Component from "@glimmer/component"
import styles from "./dangling-lesson-notice.module.css"

export default class PlannerCardStacksLessonDanglingLessonNoticeComponent extends Component {
  readonly styles = styles
}
